module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-section c-section--home"
  }, [_c('div', {
    staticClass: "o-container"
  }, [_c('div', {
    staticClass: "c-inari c-inari--home"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-home-columns"
  }, [_c('div', {
    staticClass: "c-home-column c-home-column--1"
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--large c-button--start",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Begin game")])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-column c-home-column--2"
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--home c-scroll--small"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('header', [_c('h2', [_vm._v("\n                  Win flights"), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                    to Japan\n                    "), _c('small', [_vm._v("with")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Side');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down c-arrow-down--mobile"
  }), _vm._v(" "), _c('button', {
    staticClass: "c-button c-button--primary c-button--start",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Begin game")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/shadow-bottom-japan.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("In Japan, finding your "), _c('strong', [_vm._v("ikigai")]), _vm._v(" is when you discover your true passion and reason for being.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Welcome old friend. I gather you are here because you heard about the Secret Scrolls of Ikigai. Remember, journeys worth taking are never easy.")]), _vm._v(" "), _c('p', [_vm._v("In Japan, we believe that the pursuit of your true passion can lead to unthinkably wonderful things. What are they? That’s for you to find out.")]), _vm._v(" "), _c('p', [_vm._v("Your journey to all the answers begin here. To unlock the secrets of ikigai, you must solve a series of riddles. If you are successful, you will have the chance to "), _c('strong', [_vm._v("win return flights to Japan")]), _vm._v(" for you and a friend and step closer to discovering your ikigai in Japan.")]), _vm._v(" "), _c('p', [_vm._v("Are you ready?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-divider-arrow"
  }, [_c('div', {
    staticClass: "c-arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3481be94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 61
// module chunks = 0